import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    logoPartnerContainer: {
      width: '100%',
      textAlign: 'center',
      marginTop: 10,
    },
    textContainer: {
      textAlign: 'right',
      fontSize: 12,
      fontWeight: 600,
      paddingRight: 5,
      color: theme.oysterTheme.shark,
    },
    logoContainer: {
      paddingLeft: 5,
      textAlign: 'left',
    },
    kushkiLogo: {
      width: 90,
    },
    openpayLogo: {
      width: 90,
    },
    redpayLogo: {
      width: '100px',
      marginTop: theme.spacing(2),
    },
    stripeLogo: {
      width: 60,
    },
    blumonLogo: {
      width: 90,
    },
    arcusLogo: {
      width: 90,
    },
    stpLogo: {
      width: 40,
    },
    belvoLogo: {
      width: 60,
    },
    fintocLogo: {
      width: 90,
    },
    monatoLogo: {
      width: 90,
    },
  }),
);

export default useStyles;
